<!--
 * @Author: DQL
 * @Date: 2020-03-30 19:02:49
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:03:06
 * @Description: file content
 -->
<template>
  <hm-layout
    ref="layout"
    :is-collapse-menu="config.isCollapseMenu"
    :has-menu-search="config.hasMenuSearch"
    :open-navtab-limit="config.openNavtabLimit"
    :app-logo="appLogo"
    :app-name="config.app.name"
    :copyright="config.copyright"
    :package-json="packageJson"
    :header-right-cog-sort="['user', 'wksWbjh', 'changePwd', 'operatingManual', 'logout']"
    @logout="handleLogout"
    @changeSubject="handleChangeSubject"
    @openMenu="handleOpenMenu"
  >
    <template
      v-slot:user
    >
      <div
        class="c-fheader__nav-item o-fheader__user"
      >
        <i
          class="kestrel-icon ki-user u-mg-r-4"
        />
        {{ currentUser.nickname }}（{{ currentUser.capacity.deptName }}）
        <span
          v-if="effectTips"
          class="o-effect-tips u-text-danger"
        >有效期至：{{ handleTimeFormat(currentUser.capacity.effectEndDate) }}</span>
      </div>
    </template>
    <!-- 维保计划待处理图标 -->
    <template
      v-if="wksWbjhIdList.length > 0"
      v-slot:wksWbjh
    >
      <div
        title="维保计划"
        @click="handleDialog('wksWbjh')"
      >
        <el-badge
          class="wbjh-badge"
          :value="wksWbjhIdList.length"
        >
          <i class="el-icon-document-copy" />
        </el-badge>
      </div>
    </template>

    <template
      v-slot:changePwd
    >
      <div
        class="c-fheader__nav-item u-pointer"
        title="修改密码"
        @click="handleDialog('changePassword')"
      >
        <i class="kestrel-icon ki-key" />
      </div>
    </template>

    <template
      v-slot:operatingManual
    >
      <div
        class="c-fheader__nav-item u-pointer"
        title="操作手册"
      >
        <a
          class="kestrel-icon ki-question"
          :href="operatingManual"
          target="_blank"
        />
      </div>
    </template>

    <!-- 修改密码窗口 -->
    <change-password-dialog
      v-if="showDialogName == 'changePassword'"
      @closeDialog="handleDialog"
    />
    <!-- 未开始维保计划列表弹窗 -->
    <wks-wbjh-dialog
      v-if="showDialogName == 'wksWbjh'"
      :wks-wbjh-id-list="wksWbjhIdList"
      @closeDialog="handleDialog"
    />
  </hm-layout>
</template>

<script>
import config from '@/config.js';
import packageJson from '../package.json';
import { logoutSys, changeSubject, getEnvInfo } from '@/features/feature.common.service';
import { wbjhService } from './features/xfwbgl/wbjh/wbjh.service';
import ChangePasswordDialog from '@/features/headerBar/changePasswordDialog.vue';
import WksWbjhDialog from '@/features/headerBar/wksWbjhDialog.vue';

export default {
  name: 'Layout',
  components: { ChangePasswordDialog, WksWbjhDialog },
  data () {
    return {
      appLogo: process.env.BASE_URL + 'assets/logo.png',
      operatingManual: process.env.BASE_URL + 'assets/消智维操作手册.pdf',
      config: config,
      packageJson: packageJson,
      showDialogName: null,
      env: process.env.NODE_ENV,
      WbjhTxTimer: null,
      wbjhTxDay: 3, // 维保计划剩余天数未开始提醒
      wksWbjhList: [],
      wksWbjhIdList: []
    };
  },
  computed: {
    // 用户信息
    currentUser () {
      return this.$HMStoreService.getUserinfo();
    },
    effectTips () {
      if (this.currentUser && (this.currentUser.roles.includes('companyManage') || this.currentUser.roles.includes('projectsManage') || this.currentUser.roles.includes('FireEngineer'))) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleTimeFormat (_time) {
      var datee = new Date(_time).toJSON();
      return new Date(+new Date(datee) + 8 * 3600 * 1000).toISOString().split('T')[0];
    },
    /**
     * @description: 退出系统
     * @param {*}
     * @return {*}
     */
    handleLogout () {
      const _this = this;
      logoutSys().then(rsp => {
        _this.$HMCookies.unset(config.localTokenName); // 清除cookie
        _this.$HMStoreService.removeUserinfo(); // 清除用户信息
        _this.$HMStoreService.resetNavTab(); // 清除导航页签navtab
        _this.$router.push('/login'); // 路由跳转登录页面
      });
    },
    /**
     * @description: 切换身份
     * @param {String} _selectedCapacity 选择的身份uuid
     * @return {*}
     */
    handleChangeSubject (_selectedCapacity) {
      this.$confirm('确认切换身份吗？切换身份，系统将重新载入！', '提示', { type: 'warning' })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: '切换身份中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          changeSubject(_selectedCapacity)
            .then(rsp => {
              /* 更新token Start */
              const token = rsp.headers[config.serverHeaderTokenName];
              this.$HMCookies.set(config.localTokenName, token);
              /* 更新token End */
              loading.close();
              this.$refs.layout.closeSwitchSubjectDialog();
              document.getElementById('preloading').style.display = 'table';
              const reloadHref = window.location.href.split(window.location.hash)[0];
              window.location.href = reloadHref;
            })
            .catch(err => {
              console.error('切换身份失败', err);
              loading.close();
            });
        });
    },
    handleOpenMenu (_menu) {
      console.log('点击菜单', _menu);
    },
    /**
     * @description: 通用显示模态框dialog组件
     * @param {String} _name 显示的模态框dialog名称
     * @param {Object} _params 模态框dialog传入参数
     * @return {*}
     */
    handleDialog (_name) {
      this.showDialogName = _name;
    },
    handleClickOpenExample () {
      window.open(location.origin + location.pathname + '#/examples');
    },
    getWbjh (lastDayTime) {
      const params = {
        sjssbmDm: this.currentUser.dept.deptCode,
        jhzt: 'WKS',
        jhkssjz: lastDayTime
      };
      wbjhService.queryList(params).then(rsp => {
        if (this.wksWbjhIdList.length > 0) {
          this.wksWbjhIdList = [];
        }
        // 存在有提醒的记录id查询
        rsp.data.forEach(item => {
          const nowTime = new Date().getTime();
          const endTime = new Date(item.jhsjZ).getTime();
          // wbjhTxDay天数的毫秒数
          const wbjhTxTime = this.wbjhTxDay * 24 * 60 * 60 * 1000;
          // 提醒时间起
          const txTimeq = endTime - wbjhTxTime;
          if (endTime <= txTimeq || (nowTime >= txTimeq && nowTime <= lastDayTime)) {
            // 计划结束时间小于提醒时间 或者 当前时间在提醒期间内，需要提醒
            this.wksWbjhIdList.push(item.id);
          }
        });
        if (this.wksWbjhIdList.length > 0) {
          this.handleDialog('wksWbjh');
        }
      });
    },
    // 获取维保计划提醒天数环境变量
    getEnvInfo () {
      getEnvInfo('WBJH_TX_DAY').then(rsp => {
        this.wbjhTxDay = parseInt(rsp.data.envValue);
        this.initWbjhTx();
        // 页面10分钟查询一次
        this.WbjhTxTimer = setInterval(() => {
          this.initWbjhTx();
        }, 1000 * 60 * 10);
      });
    },
    // 初始化维保计划提醒
    initWbjhTx () {
      const nowMonth = new Date().getMonth();
      const nowYear = new Date().getFullYear();
      const lastDay = new Date(nowYear, nowMonth + 1, 0).getDate();
      const lastDayTime = new Date(nowYear, nowMonth, lastDay).getTime();
      this.getWbjh(lastDayTime);
    }
  },
  mounted () {
    // 新业务系统专属角色无旧功能维保数据，跳过维保计划到期提醒检查
    const gnmkRoles = ['SJGLY', 'RWGLY', 'RWZXY', 'GZCLY', 'ZYSHRY'];
    const roles = this.currentUser.roles || [];
    if (!roles.some(role => gnmkRoles.includes(role))) {
      this.getEnvInfo();
    }
    console.log(this.$HMThemeService);
  },
  destroyed () {
    clearInterval(this.WbjhTxTimer);
  }
};
</script>

<style lang="scss">
.o-fheader__user{
  position: relative;
}

.o-effect-tips{
  position: absolute;
  right: 20px;
  bottom: 4px;
  line-height: 1.1;
}

.wbjh-badge{
  height: 18px;
  width: 18px;
  margin-left: 5px;
  margin-right: 14px;
}

.wbjh-badge .el-icon-document-copy{
  position: fixed;
  font-size: 16px;
  line-height: 18px;
  height: 18px;
  width: 18px;
}
</style>
